<div class="hts-assistant-thread" #scrollingContainer>
  <ng-container *ngFor="let item of visibleItems; trackBy: trackByKey" [ngSwitch]="item.kind">
    <app-hts-assistant-message
      *ngSwitchCase="kinds.Message"
      [role]="item.role"
      [content]="item.content"
      [isDimmed]="item.isDimmed"
    ></app-hts-assistant-message>

    <div *ngSwitchCase="kinds.Separator" class="hts-assistant-thread__separator">
      <span>{{ "HTS_ASSISTANT.NEW_CONVERSATION" | translate }}</span>
    </div>

    <app-hts-assistant-result-card
      *ngSwitchCase="kinds.Result"
      [result]="item.result"
      [isStale]="item.isStale"
      [isReadonly]="isReadonly"
      [isShowInsert]="isShowInsert"
      [isDisabled]="isActionsDisabled"
      [isInserted]="item.isInserted"
      [isSaved]="item.isSaved"
      [isInCatalog]="item.isInCatalog"
      [isInserting]="item.isInserting"
      [isSaving]="item.isSaving"
      [isDimmed]="item.isDimmed"
      [isStartOverAvailable]="item.isStartOverAvailable"
      (insert)="insert.emit(item.conversationId)"
      (saveToCatalog)="saveToCatalog.emit(item.conversationId)"
      (startOver)="startOver.emit()"
    ></app-hts-assistant-result-card>

    <app-hts-assistant-thinking *ngSwitchCase="kinds.Thinking"></app-hts-assistant-thinking>

    <div *ngSwitchCase="kinds.Note" class="hts-assistant-thread__note" [class.hts-assistant-thread__note--dimmed]="item.isDimmed">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <span>{{ item.content | translate : item.params }}</span>
    </div>

    <div *ngSwitchCase="kinds.Restart" class="hts-assistant-thread__restart">
      <span class="hts-assistant-thread__restart-note">{{ item.content | translate }}</span>
      <button type="button" class="hts-assistant-thread__restart-button" [disabled]="isActionsDisabled" (click)="startOver.emit()">
        <i class="fa fa-refresh" aria-hidden="true"></i>
        {{ "HTS_ASSISTANT.START_OVER" | translate }}
      </button>
    </div>

    <div
      *ngSwitchCase="kinds.NoAnswer"
      class="hts-assistant-thread__no-answer"
      [class.hts-assistant-thread__no-answer--stale]="item.isStale"
      [class.hts-assistant-thread__no-answer--dimmed]="item.isDimmed"
    >
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <span class="hts-assistant-thread__no-answer-text">{{ "HTS_ASSISTANT.NO_ANSWER_NOTE" | translate }}</span>
      <button
        *ngIf="item.isStartOverAvailable"
        type="button"
        class="hts-assistant-thread__restart-button"
        [disabled]="isActionsDisabled"
        (click)="startOver.emit()"
      >
        <i class="fa fa-refresh" aria-hidden="true"></i>
        {{ "HTS_ASSISTANT.START_OVER" | translate }}
      </button>
    </div>
  </ng-container>
</div>
